import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-233" data-mp="3fym5ug9teu28">
      <div className="mx-auto w-full max-w-2xl" data-id="element-234" data-mp="3b0kmrvce2uqr">
        <h2 className="text-center font-display text-[1.65rem] font-bold leading-tight text-navy sm:text-4xl" data-id="element-235" data-mp="3azt4fm7sytif">
          Lo que ya están logrando otros médicos
        </h2>

        <div className="mt-8 space-y-4" data-id="element-236" data-mp="31zmto83ho7my">
          {testimonials.map(t => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.4
        }} className="rounded-2xl border border-navy/10 bg-cream p-5" data-id="element-237" data-mp="2x0jn2j7v1tcv">
              <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-238" data-mp="qbeqn195u1d5">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-239" data-mp="h818fqfnqklj" data-mpi={i} />)}
              </div>
              <blockquote className="mt-3 text-[15px] italic leading-relaxed text-navy/80 sm:text-base" data-id="element-240" data-mp="78aatfvsvph8">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3" data-id="element-241" data-mp="c8y11zc7g2ae">
                <img src={t.image} alt={`Retrato de ${t.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-gold/50" loading="lazy" data-id="element-242" data-mp="zxr0w6vy6uaa" />
                <div data-id="element-243" data-mp="v5psiw1whnpj">
                  <p className="text-sm font-bold text-navy" data-id="element-244" data-mp="v57lr5hm3r3d">{t.name}</p>
                  <p className="text-xs text-navy/55" data-id="element-245" data-mp="v3d3y01n0f3i">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>

        <div className="mt-9" data-id="element-246" data-mp="1nnla8eh260ps">
          <CTAButton label="Quiero los mismos resultados" note="Más de 2.000 médicos ya lo utilizan" data-id="element-247" data-mp="1nnv0m360m9w0" />
        </div>
      </div>
    </section>;
}